import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation createHappeningMutation($input: CreateHeroOfferInput!) {
    createHeroOffer(input: $input) {
      heroOfferEdge {
        node {
          ...HappeningCell_happening
        }
      }
      lists {
        ...HappeningsContainer_lists
      }
      errors {
        key
        messages
      }
    }
  }
`;

const createHappening = (environment, attributes, listsId, args = {}) => {
  const { backgroundImage, ...otherAttributes } = attributes;

  const uploadables = backgroundImage
    ? { happeningBackgroundImage: backgroundImage }
    : null;

  return commit(environment, {
    mutation,
    uploadables,
    variables: {
      input: otherAttributes,
    },
    configs: [
      {
        type: 'RANGE_ADD',
        parentID: listsId,
        edgeName: 'heroOfferEdge',
        connectionInfo: [
          {
            key: 'HappeningsContainer_heroOffers',
            rangeBehavior: 'append',
          },
        ],
      },
    ],
    ...args,
  });
};

export default createHappening;
